<div class="segment">
  {{>slot}}
</div>
